// removed by extract-text-webpack-plugin
module.exports = {"table":"src-components-TechSpecTable----TechSpecTable-module---table---19E07","selected":"src-components-TechSpecTable----TechSpecTable-module---selected---3j0jQ","heading":"src-components-TechSpecTable----TechSpecTable-module---heading---3EKNT","cell":"src-components-TechSpecTable----TechSpecTable-module---cell---BeHnE","row":"src-components-TechSpecTable----TechSpecTable-module---row---Sdgoa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TechSpecTable/TechSpecTable.module.scss
// module id = 1207
// module chunks = 137591856104208